import { render, staticRenderFns } from "./AppointmentButton.vue?vue&type=template&id=3c2dc279&scoped=true"
import script from "./AppointmentButton.vue?vue&type=script&lang=js"
export * from "./AppointmentButton.vue?vue&type=script&lang=js"
import style0 from "./AppointmentButton.vue?vue&type=style&index=0&id=3c2dc279&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2dc279",
  null
  
)

export default component.exports